<template>
    <v-row>
        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.nombre" :label="$t('cobrox.estadoDeuda.labels.nombre')" icon="badge"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.cancelaSaldos" :label="$t('cobrox.estadoDeuda.labels.cancelaSaldos')" icon="highlight_off"/>
            </v-list>
        </v-col>

        <v-col cols="12" sm="6" md="4">
            <v-list>
                 <show-field :value="item.cancelaSaldosHistorico" :label="$t('cobrox.estadoDeuda.labels.cancelaSaldosHistorico')" icon="history"/>
            </v-list>
        </v-col>

    </v-row>
</template>
<script>
    import {ShowField} from '@dracul/common-frontend'
     
    
    export default {
        name: 'EstadoDeudaShowData',
        components: {ShowField},
        
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

